"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = __importDefault(require("styled-components"));

const Row_1 = __importDefault(require("../row/Row"));

const Snackbar = styled_components_1.default(Row_1.default).attrs(props => ({
  crossAxisAlignment: 'center',
  onMouseEnter: () => {
    var _a;

    (_a = props.timer) === null || _a === void 0 ? void 0 : _a.pause();
  },
  onMouseLeave: () => {
    var _a;

    (_a = props.timer) === null || _a === void 0 ? void 0 : _a.resume();
  }
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: black;\n  color: white;\n  padding: 16px;\n  margin: 16px;\n"])));
exports.default = Snackbar;